 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 模板类型  访问级别
  */
 let EnumAccessLevel = {
     InternalDepartment : new EnumItem('部门内部访问', 0),
     DepartmentExternal : new EnumItem('部门外部访问', 1),
     ...enumMixn
 }
 export default EnumAccessLevel
 